<div class="p-4 flex gap-8" [class.md:w-[832px]]="completed()">
  <div class="relative hidden md:block" [class.w-full]="completed()" [class.!block]="completed()">
    <img
      ngSrc="/assets/images/membership/blue-bg.png"
      width="800"
      height="450"
      alt="Bronze"
      aria-hidden="true"
      class="w-[416px] h-[419px] object-cover rounded-lg transition-all duration-500"
      priority
      [class.w-full]="completed()"
    />

    @if (lottieAnimationInitialized()) {
      <div class="absolute inset-0 flex items-center justify-center">
        <ng-lottie
          [options]="lottieOptions()"
          width="100%"
          height="100%"
          [styles]="{ objectFit: 'contain' }"
          (complete)="lottieAnimationInitialized.set(false)"
        />
      </div>
    }

    <div
      class="absolute top-1/2 left-1/2 -translate-x-1/2 transition-all duration-500 ease-out opacity-0 text-center w-full flex flex-col items-center"
      [class.opacity-100]="slideUpAnimationInitialized()"
      [class]="slideUpAnimationInitialized() ? '-translate-y-1/2' : 'translate-y-0'"
    >
      <div>
        <h1 class="text-white !text-5xl font-bold">{{ 'membership.tokens.buy.success.title' | transloco }}</h1>
        <p class="mt-4 text-white text-sm">
          {{ 'membership.tokens.buy.success.description' | transloco: { amount: amount.value } }}
        </p>
      </div>

      <a ui-kit-button [variant]="'secondary'" class="w-fit mt-4" [routerLink]="['/search']" dialogClose>
        {{ 'membership.tokens.buy.success.cta' | transloco }}
      </a>
    </div>

    @if (!completed()) {
      <h2
        class="absolute left-4 bottom-4 text-white flex items-end gap-x-2 transition-all duration-500"
        [innerHTML]="'common.searches' | transloco: { searches: amount.value }"
      ></h2>
    }
  </div>
  <div class="min-w-full md:min-w-[416px]" [class.hidden]="completed()">
    <div class="dialog-header flex justify-between items-center">
      <p class="font-semibold">{{ 'membership.tokens.buy' | transloco }}</p>
      <button dialogClose>
        <img src="/assets/images/icons/close-dialog.svg" alt="Close" />
      </button>
    </div>

    <div class="dialog-content mt-4">
      <form class="flex flex-col gap-4" [formGroup]="buyTokensForm">
        <div>
          <label class="text-xs" [attr.for]="'credit-amount'">
            {{ 'membership.tokens.buy.credit-amount' | transloco }}
          </label>
          <div class="flex gap-1 items-end">
            <button ui-kit-button [variant]="'secondary'" (click)="updateAmount(amount.value - 1)" type="button">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M3.33301 7.33398H12.6663V8.66732H3.33301V7.33398Z" fill="#181D20" />
              </svg>
            </button>
            <div class="flex-1">
              <ui-kit-input [type]="'number'" [mask]="'000'" [id]="'credit-amount'" formControlName="amount" />
            </div>
            <button ui-kit-button [variant]="'secondary'" (click)="updateAmount(amount.value + 1)" type="button">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  d="M7.33301 7.33398V3.33398H8.66634V7.33398H12.6663V8.66732H8.66634V12.6673H7.33301V8.66732H3.33301V7.33398H7.33301Z"
                  fill="#181D20"
                />
              </svg>
            </button>
          </div>
        </div>

        <div>
          <div class="flex items-center justify-between mb-1">
            <label class="text-xs" [attr.for]="'billing-address'">
              {{ 'membership.tokens.buy.billing-address' | transloco }}
            </label>

            <button class="text-xs underline text-primary" (click)="changePaymentInformation()">
              {{ 'common.edit' | transloco }}
            </button>
          </div>
          <ui-kit-textarea [disabled]="true" formControlName="billingAddress" [id]="'billing-address'" />
        </div>

        <div>
          <div class="flex items-center justify-between mb-1">
            <label class="text-xs" [attr.for]="'credit-card'">
              {{ 'membership.tokens.buy.credit-card' | transloco }}
            </label>

            <button class="text-xs underline text-primary" (click)="changePaymentInformation()">
              {{ 'common.change-card' | transloco }}
            </button>
          </div>
          <ui-kit-input [disabled]="true" formControlName="creditCard" [id]="'credit-card'" />
        </div>

        <hr class="w-full" />

        <ui-kit-badge
          [type]="'primary'"
          [additionalClasses]="'rounded-lg font-normal'"
          class="w-full"
          [class.invisible]="!discountPercentage()"
        >
          {{
            'membership.discount'
              | transloco
                : {
                    plan: 'membership.plan.' + (subscriptionPlan() | lowercase) | transloco,
                    discount: discountPercentage() | number: '1.0-0',
                  }
          }}
        </ui-kit-badge>

        <div class="flex justify-end items-center gap-x-2">
          <span class="font-semibold">
            {{ 'common.total' | transloco }}:
            {{ defaultPrice() * amount.value * discountValue() | currency: currency() }}

            @if (discountPercentage()) {
              <span class="font-normal line-through ml-1">
                {{ defaultPrice() * amount.value | currency: currency() }}
              </span>
            }
          </span>
          <button ui-kit-button [isLoading]="loading()" type="button" (click)="buy()">
            {{ 'membership.tokens.buy.confirm' | transloco }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
